import VideoJS from 'video.js';


export const ASControl = function (name, classes, innerHTML = '') {
	const Component = VideoJS.getComponent('Component');
	const Control = VideoJS.extend(Component, {});

	Control.prototype.createEl = function () {
	    return Component.prototype.createEl.call(this, 'div', {
	        className: classes,
	        innerHTML: innerHTML
	    });
	};

	VideoJS.registerComponent(name, Control);

	return name;
};


export const ASFullscreenToggle = function (name, classes, innerHTML = '') {
	const Component = VideoJS.getComponent('FullscreenToggle');
	const ASIcon = VideoJS.extend(Component, {});

	ASIcon.prototype.createEl = function () {
	    return Component.prototype.createEl.call(this, 'span', {
	        className: classes,
	        innerHTML: innerHTML
	    });
	};

	VideoJS.registerComponent(name, ASIcon);

	return name;
};


export const ASPlayToggle = function (name, classes, innerHTML = '') {
	const Component = VideoJS.getComponent('PlayToggle');
	const ASIcon = VideoJS.extend(Component, {});

	ASIcon.prototype.createEl = function () {
	    return Component.prototype.createEl.call(this, 'span', {
	        className: classes,
	        innerHTML: innerHTML
	    });
	};

	VideoJS.registerComponent(name, ASIcon);

	return name;
};


export const ASMuteToggle = function (name, classes, innerHTML = '') {
	const Component = VideoJS.getComponent('MuteToggle');
	const ASIcon = VideoJS.extend(Component, {});

	ASIcon.prototype.createEl = function () {
	    return Component.prototype.createEl.call(this, 'span', {
	        className: classes,
	        innerHTML: innerHTML
	    });
	};

	VideoJS.registerComponent(name, ASIcon);

	return name;
};






// WEBPACK FOOTER //
// ./src/ui/VideoJSComponents.js